import {
	type createBoMenuItemClickEvent,
	BackofficeShell,
} from '@yoummday/backoffice-core';
import '@yoummday/yd-components/dist/components/yd-dialog';
import { createNavigateEvent } from '@yoummday/ymmd-platform-core/comp/app-shell';
import { html, render } from 'lit';
import { customElement } from 'lit/decorators.js';
import { when } from 'lit/directives/when.js';
import { API } from '../../api';
import { Router } from '../../router';
// change this to a unique name (adopt class name and html element name accordingly)
const backofficeName = 'billing';

@customElement(`backoffice-${backofficeName}`)
export default class BackofficeBilling extends BackofficeShell {
	backofficeName = backofficeName;

	override async fetchMenuData() {
		const { data = {} } = await API.GET('/billing/v1/menu/list');
		return data;
	}

	connectedCallback() {
		super.connectedCallback();
		Router.subscribe((route, params, queryParams) => {
			if (!route.routeDefaultExport) return;
			this.view = new route.routeDefaultExport();
			if (!this.view) return;
			this.view.route = route;
			this.view.params = params || {};
			this.view.query = queryParams || {};
			render(this.view, this);
			this.route = route;
		});
	}

	onNavigate(e: ReturnType<typeof createNavigateEvent>) {
		Router.navigate(e.detail);
	}

	onMenuItemClick({ detail }: ReturnType<typeof createBoMenuItemClickEvent>) {
		if (detail.belongsToCurrentBackoffice) {
			this.dispatchEvent(
				createNavigateEvent(
					detail.path.replace(import.meta.env.BASE_URL, '/')!,
				),
			);
		} else {
			window.location.href = detail.path!;
		}
	}

	// eslint-disable-next-line max-lines-per-function
	render() {
		return html`
			${when(
				this.isLoading,
				() => html`
					<div class="loading-bar"></div>
				`,
			)}
			<sl-page-layout
				collapsible
				@sl-toggle-navigation=${(e: CustomEvent) => {
					this.isNavigationCollapsed = e.detail.collapsed;
					this.menuElement.isNavigationCollapsed = this.isNavigationCollapsed;
				}}
			>
				${when(
					this.route?.hasHeader,
					() => html`
						<sl-page-header slot="header">
							<sl-button
								slot="right"
								variant="primary"
								@click=${() => {
									API.POST('/logout');
								}}
							>
								Logout
							</sl-button>
						</sl-page-header>
					`,
				)}
				${when(
					this.route?.hasAsideNavigation,
					() => html`
						<sl-page-aside slot="aside">
							${this.getMenu.render({
								complete: (menuElement) => html`
									<div
										slot="center"
										@bo-menu-item-click=${this.onMenuItemClick}
									>
										${Object.assign(menuElement, {
											currentPath: window.location.pathname,
										})}
									</div>
								`,
							})}
						</sl-page-aside>
					`,
				)}

				<sl-page-content slot="main">
					<slot></slot>
				</sl-page-content>
			</sl-page-layout>

			${when(this.dialog, () => this.renderDialog())}
		`;
	}
}

declare global {
	interface HTMLElementTagNameMap {
		'backoffice-billing': BackofficeBilling;
	}
}
